export class SwitchState {
  constructor(
    { element, state = false },
    handleStateTrueEvent,
    handleStateFalseEvent
  ) {
    this.state = state
    this.element = element
    this.on = handleStateTrueEvent
    this.off = handleStateFalseEvent
    if (this.element) {
      this.element.addEventListener('click', () => {
        this.state = !this.state
        this.call()
      })
    }
  }
  call() {
    if (this.state) {
      this.on()
    } else {
      this.off()
    }
  }
}
